import { hotKeywords, hotTrends } from "@/mocks/chigua";

interface RankingRailProps {
  onKeyword: (keyword: string) => void;
}

function heatColor(heat: string) {
  if (heat === "沸") return "bg-primary-500 text-background-50";
  if (heat === "新") return "bg-accent-500 text-foreground-950";
  return "bg-secondary-200 text-secondary-900";
}

export default function RankingRail({ onKeyword }: RankingRailProps) {
  return (
    <aside className="flex flex-col gap-5">
      {/* 热搜榜 */}
      <section id="hot" className="scroll-mt-24 rounded-lg border border-background-200 bg-background-100 p-5">
        <div className="flex items-center justify-between">
          <h2 className="font-heading text-lg font-black text-foreground-950">
            <span className="mr-2 inline-flex h-6 w-1.5 translate-y-0.5 rounded-full bg-accent-500"></span>
            全网热搜
          </h2>
          <span className="inline-flex items-center gap-1 font-label text-xs font-medium text-foreground-500">
            <i className="ri-funds-line text-accent-600"></i>
            实时更新
          </span>
        </div>
        <ol className="mt-4 space-y-3.5">
          {hotTrends.map((t) => (
            <li key={t.rank}>
              <div className="flex items-start gap-3">
                <span
                  className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded font-label text-sm font-black ${
                    t.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-400"
                  }`}
                >
                  {t.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium leading-snug text-foreground-900 line-clamp-1">
                    {t.title}
                  </p>
                  <div className="mt-1 flex items-center gap-2">
                    <span className="text-xs text-foreground-400">热度 {hotTrends.length * 1000 + (hotTrends.length - t.rank) * 3200}万</span>
                    <span
                      className={`inline-flex items-center gap-0.5 rounded px-1.5 py-0.5 font-label text-[10px] font-bold ${heatColor(t.heat)}`}
                    >
                      <i className="ri-flashlight-fill"></i>
                      {t.heat}
                    </span>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </section>

      {/* 热词标签云 */}
      <section className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h2 className="font-heading text-base font-black text-foreground-950">热词追踪</h2>
        <div className="mt-4 flex flex-wrap gap-2">
          {hotKeywords.map((k) => (
            <button
              key={k}
              type="button"
              onClick={() => onKeyword(k)}
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-50 px-3.5 py-1.5 text-sm text-foreground-700 ring-1 ring-background-300 transition hover:bg-primary-500 hover:text-background-50 hover:ring-primary-500"
            >
              <i className="ri-price-tag-3-line text-xs text-primary-500"></i>
              {k}
            </button>
          ))}
        </div>
        <p className="mt-4 text-xs leading-relaxed text-foreground-500">
          点击热词可快速检索相关资讯，追踪你关注的每一个话题走向。
        </p>
      </section>
    </aside>
  );
}